export default __webpack_public_path__ + "static/media/cy.5322bdf8.svg";